import React from "react";
import PropTypes from "prop-types";

const CactusTwo = ({ className, id }) => (
  <svg viewBox="0 0 64 93" fill="none" id={id} className={className}>
    <path
      d="M24.5882 78.7787L24.0342 91.4801L42.8841 92C42.8841 88.0548 43.1997 80.1006 43.1997 80.1006C43.1997 80.1006 42.8841 73.7372 43.1997 67.1444C43.3527 63.9484 48.4806 68.8182 51.3386 67.1444C54.2519 65.438 55.8576 63.4913 57.9503 60.474C60.6438 56.5904 61.5493 53.8742 62.4609 49.2275C63.1 45.97 62.9933 45.513 62.9933 40.7421V34.7885C62.9933 34.7885 62.7979 30.3382 61.3267 28.3222C60.0792 26.6128 58.7386 25.6126 56.3323 25.726C53.9259 25.8394 52.3257 27.1997 51.3386 29.3715C50.441 31.3461 50.0913 32.6169 50.0913 34.7885C50.0913 37.8258 50.1683 48.607 47.1634 50.546C45.7766 51.441 45.4662 51.9421 45.4662 48.3303C45.4662 45.3181 45.1602 35.8092 45.1602 35.8092C45.1602 35.8092 44.7211 27.6479 44.3896 24.7178C44.0181 21.4342 43.8997 19.6391 43.4651 16.3411C43.1155 13.6878 42.7812 11.837 42.2323 9.5155C41.619 6.92142 41.7844 5.95313 40.2291 3.93093C38.254 1.36284 35.4188 0.664052 32.4472 1.1387C29.4756 1.61335 27.4869 4.53475 25.6668 6.95595C23.9357 9.25881 23.0013 15.1159 23.0013 15.1159C23.0013 15.1159 22.2267 23.384 22.2267 26.4241C22.2267 32.8379 23.0013 34.7885 22.2267 42.4528C22.044 44.2599 22.1657 46.668 20.2735 46.668C18.5444 46.3256 17.2099 45.1068 15.9114 43.4218C13.7537 40.622 13.6473 29.449 13.6473 29.449C13.6473 29.449 13.6473 20.2967 12.6456 16.3411C11.644 12.3854 7.08032 14.2563 5.94005 14.741C4.07956 15.5318 2.704 17.8745 2.704 17.8745C2.704 17.8745 1.57336 21.1551 1.24082 23.0382C0.383696 27.8916 2.09001 39.1747 2.09001 39.1747C2.09001 39.1747 3.0916 50.4685 5.63421 53.6486C7.31088 55.7456 10.3903 57.6316 12.6456 59.0779C15.9114 61.1721 18.6204 61.5684 23.0013 64.3521C24.5882 65.3604 24.0342 65.8258 24.5882 68.5405C25.0719 70.9107 24.5882 77.0857 24.5882 78.7787Z"
      fill="#C4C4C4"
      stroke="black"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CactusTwo.defaultProps = {
  className: ``,
  id: undefined
};

CactusTwo.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string
};

export default CactusTwo;
